import { takeEvery, call, put } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import APIENDPOINTS from '../../constants/apiconstants';
import { saveData } from '../service/saveDataService';
import { getData } from '../service/getDataService';
import {
	setColumnPreferencesFailure,
	setColumnPreferencesSuccess,
	getUserPreferencesSuccess,
	getUserPreferencesFailure,
	getColumnListSuccess,
	getColumnListFailure,
} from '../actions/customTableColumnAction';
import { setFirstTimeUser } from '../actions/appGuideActions';

import { defaultColumnPreferences } from './utils';

export function* savePreferencesSaga(action) {
	const { portalUserContext, request } = action.payload;

	try {
		const apiUrl = `${APIENDPOINTS.SAVE_PREFERENCES}`;

		const response = yield call(
			saveData,
			request,
			apiUrl,
			portalUserContext.result
		);

		if (response?.statusCode > 200) {
			yield put(setColumnPreferencesFailure(response?.statusCode));
		} else {
			yield put(setColumnPreferencesSuccess(response?.statusCode));
		}
	} catch (error) {
		yield put(setColumnPreferencesFailure(error));
	}
}

export function* getUserPreferencesSaga(action) {
	const { portalUserContext, metricsResponse } = action.payload;

	try {
		const apiUrl = APIENDPOINTS.GET_PREFERENCES;

		const response = yield call(getData, apiUrl, portalUserContext.result);
		if (response?.statusCode > 200) {
			yield put(getUserPreferencesFailure(response?.statusCode));
		} else {
			// For first-time user, insightPreferences array will not be present in the response
			if (response?.json?.insightPreferences?.length > 0) {
				yield put(
					getUserPreferencesSuccess({
						result:
							response?.json?.insightPreferences[0]?.channels ||
							defaultColumnPreferences,
						metricsResponse: metricsResponse,
					})
				);
			} else {
				yield put(
					getUserPreferencesSuccess({
						result: defaultColumnPreferences,
						metricsResponse: metricsResponse,
					})
				);
			}
			// Set the flag for the First time user experience
			yield put(
				setFirstTimeUser({
					firstTimeUser: response?.json?.firstTimeUser,
					dsADAlertDisabled: response?.json.dsADAlertDisabled,
				})
			);
		}
	} catch (error) {
		yield put(getUserPreferencesFailure(error));
	}
}

export function* getColumnListSaga(action) {
	const { portalUserContext } = action.payload;

	try {
		const apiUrl = APIENDPOINTS.METRICS;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode > 200) {
			yield put(getColumnListFailure(response?.statusCode));
		} else {
			yield put(
				getColumnListSuccess({ result: response?.json?.result[0]?.channels })
			);
			yield put({
				type: actionTypes.GET_USER_PREFERENCES,
				payload: {
					portalUserContext,
					metricsResponse: response?.json?.result[0]?.channels,
				},
			});
		}
	} catch (error) {
		yield put(getColumnListFailure(error));
	}
}

export function* customTableSagaWatcher() {
	yield takeEvery(actionTypes.SET_COLUMN_PREFERENCES, savePreferencesSaga);
	yield takeEvery(actionTypes.GET_USER_PREFERENCES, getUserPreferencesSaga);
	yield takeEvery(actionTypes.GET_COLUMN_LIST, getColumnListSaga);
}
